"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.roamBlockReferenceTitlePrefix = exports.roamBlockEmbedTitlePrefix = exports.roamBlockTitlePrefix = exports.hashtagTitlePrefix = void 0;
const unist_util_visit_1 = __importDefault(require("unist-util-visit"));
const slugify_1 = __importDefault(require("slugify"));
// Find matches for content between double parenthesis
// e.g. ((Example)) -> Example
const parenthesisRegex = /\(\(([^)]+)\)\)/g;
// {{embed: ((reference))}} or {{[[embed]]: ((reference))}}
const embedRegex = /{{\s*\[?\[?embed]?]?\s*:\s*\(\(([^)]+)\)\)\s*}}/g;
// #stuff #more-stuff
const hashtagRegex = /(?<=^|\s)#([^\s]+)/g;
// todo package name does not really match the purpose anymore 😅
const addDoubleParenthesisLinks = ({ markdownAST }, options) => {
    const idToURL = (options === null || options === void 0 ? void 0 : options.idToURL) || ((title) => `/${slugify_1.default(title)}`);
    unist_util_visit_1.default(markdownAST, `text`, embedVisitor);
    unist_util_visit_1.default(markdownAST, `text`, referenceVisitor);
    unist_util_visit_1.default(markdownAST, `text`, hashTagVisitor);
    function embedVisitor(node, index, parent) {
        const value = node.value;
        if (typeof value !== "string" || !Array.isArray(parent.children)) {
            return;
        }
        const children = transformMatchToLink(value, embedRegex);
        if (!children)
            return;
        replaceNodeWithResults(parent.children, index, children, exports.roamBlockEmbedTitlePrefix);
    }
    function referenceVisitor(node, index, parent) {
        const value = node.value;
        if (typeof value !== "string" || !Array.isArray(parent.children)) {
            return;
        }
        const children = transformMatchToLink(value, parenthesisRegex);
        if (!children)
            return;
        replaceNodeWithResults(parent.children, index, children, exports.roamBlockReferenceTitlePrefix);
    }
    function hashTagVisitor(node, index, parent) {
        const value = node.value;
        if (typeof value !== "string" || !Array.isArray(parent.children)) {
            return;
        }
        const children = transformMatchToLink(value, hashtagRegex);
        if (!children)
            return;
        replaceNodeWithResults(parent.children, index, children, exports.hashtagTitlePrefix);
    }
    function replaceNodeWithResults(parentElements, index, children, titlePrefix) {
        parentElements.splice(index, 1, ...children.map((child) => {
            if (typeof child === "string") {
                return {
                    type: "text",
                    value: child,
                };
            }
            return {
                type: "link",
                url: idToURL(child.id),
                title: `${titlePrefix}${child.id}`,
                children: [{ type: "text", value: child.id }],
            };
        }));
    }
};
function transformMatchToLink(value, regexp) {
    const matches = [...value.matchAll(regexp)];
    if (!matches.length)
        return null;
    const children = [value];
    matches.forEach((match) => {
        const last = children.pop();
        if (typeof last !== "string") {
            return;
        }
        const split = match[0];
        const [first, ...rest] = last.split(split);
        children.push(first, { id: match[1] }, rest.join(split));
    });
    return children;
}
exports.hashtagTitlePrefix = `hashtag_`;
exports.roamBlockTitlePrefix = `__roam_block_`;
exports.roamBlockEmbedTitlePrefix = `${exports.roamBlockTitlePrefix}embed_`;
exports.roamBlockReferenceTitlePrefix = `${exports.roamBlockTitlePrefix}reference_`;
exports.default = addDoubleParenthesisLinks;
//# sourceMappingURL=index.js.map